module.exports = __webpack_public_path__ + "static/media/acceleron_logo_white.0da87e90.svg";